import {bind} from 'ramda';

export const createElement = bind(document.createElement, document);
export const createElementNS = bind(document.createElementNS, document);
